import { FC } from 'react';

import { useTouring } from 'components/self-tour/hooks/useTouring';

import { FloatingCTA } from './PropertySection/FloatingCTA';
import { TourWithAgentModal } from './PropertySection/TourWithAgentModal';
import { PropertyDetailsType } from './types';

interface FooterCTAProps {
  property: PropertyDetailsType;
  isVisible?: boolean;
}

export const FooterCTA: FC<FooterCTAProps> = ({ property, isVisible = true }) => {
  const touringInfo = useTouring(property, { placement: 'footer' });

  // Only show FooterCTA for actionable properties
  if (!touringInfo) {
    return null;
  }

  const { primaryAction, secondaryAction, tourKind, isDialogOpen, closeDialog } = touringInfo;

  return (
    <>
      <FloatingCTA
        ctaText={primaryAction.text}
        onClickCta={primaryAction.onClick}
        ctaHref={primaryAction.href}
        isLiked={property.isLiked}
        onClickReaction={property.onClickReaction}
        variant={primaryAction.variant}
        isVisible={isVisible}
        disabled={primaryAction.disabled}
        showSecondaryButton={!!secondaryAction}
        secondaryButtonText={secondaryAction?.text}
        secondaryButtonHref={secondaryAction?.href}
        onClickSecondary={secondaryAction?.onClick}
      />
      {tourKind === 'tourWithAgent' && (
        <TourWithAgentModal property={property} isOpen={isDialogOpen} onClose={closeDialog} />
      )}
    </>
  );
};
